import { render, staticRenderFns } from "./ad-target.vue?vue&type=template&id=54751368&scoped=true"
import script from "./ad-target.vue?vue&type=script&lang=js"
export * from "./ad-target.vue?vue&type=script&lang=js"
import style0 from "./ad-target.vue?vue&type=style&index=0&id=54751368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54751368",
  null
  
)

export default component.exports